<template>
	<input :value="value"
		   @input="$emit('input', $event.target.value)"
		   :placeholder="config.placeholder"
		   ref="input"
		   :disabled="disabled"
	/>
</template>

<script>
import {client} from "@/store";

export default {
	components: {},
	data() {
		return {
			options: []
		};
	},

	props: {
		config: {
			type: Object,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		variables: {
			type: Object,
			default: {}
		},
		value: {
			type: String | Number,
			default: ""
		}
	},

	created() {
		this.getData();
	},
	methods: {
		getData() {
			const variableData = {};
			this.config.variables.forEach(variable => {
				variableData[variable] = this.variables[variable];
			});
			const query = atob(this.config.query);
			client.query(query, variableData)
				.then(response => {
					const value = this.config.dataPath.reduce((data, path) => data[path], response)[this.config.value];
					this.$refs.input.value = value
					this.$emit('input', value);
				})
				.catch(error => {
					console.log(error);
				});
		}
	}
};
</script>

<style scoped lang="scss">

</style>
